/* Muir Way | 2D PDP size rows: auto-show the size image.
   Loaded from snippets/mw-size-test.liquid. Won as an Intelligems test, mobile only.

   Every size change switches the gallery to the "sizes on your wall" image.
   Not on page load. The "See sizes on your wall" link, prices, frame selector
   and add to cart are untouched. Only active while <html> has mw-size-test. */
(function () {
  'use strict';

  var root = document.documentElement;
  function active() { return root.classList.contains('mw-size-test'); }

  function setup() {
    var gallery = document.querySelector('media-gallery');
    var slide = gallery && gallery.querySelector('.main-image [data-media-id="mw-sizes"]');
    var picker = document.querySelector('variant-picker');
    var sizeFs = picker && picker.querySelector('fieldset.mw-sr');
    if (!gallery || !slide || !sizeFs || typeof gallery.setActiveMedia !== 'function') return false;
    if (gallery.mwAutoShow) return true;
    gallery.mwAutoShow = true;

    // Size image shows THIS map on every product: the product's own flat artwork
    // (its "No Frame" variant image), measured and fitted exactly to each print.
    personalize(gallery, picker);

    // Block the gallery's jump to the variant photo for this one change, then show the size image.
    var hold = false;
    var orig = gallery.setActiveMedia;
    gallery.setActiveMedia = function (id) {
      if (hold && String(id) !== 'mw-sizes') return;
      return orig.apply(this, arguments);
    };

    function currentSize() {
      var c = sizeFs.querySelector('input:checked');
      return c ? c.value : null;
    }
    var lastSize = currentSize();

    picker.addEventListener('on:variant:change', function () {
      var size = currentSize();
      if (size === lastSize) return; // frame / style change: leave as is
      lastSize = size;
      if (!active()) return;
      hold = true;
      setTimeout(function () {
        hold = false;
        // The theme can throw while scrolling the thumbnail strip; the main image is already switched by then.
        try { gallery.setActiveMedia('mw-sizes', true); } catch (e) {}
        // Make sure the main gallery really scrolls to it (the theme skips this in some states).
        var track = slide.closest('.slider');
        if (track && Math.abs(track.scrollLeft - slide.offsetLeft) > 2) {
          track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        }
      }, 0);
    });
    return true;
  }

  // The artwork sits centred on white inside a square file. Measure where it is (light canvas pass on a
  // 300px copy), then scale and centre that box onto each print rectangle so nothing is cut or padded.
  function personalize(gallery, picker) {
    var imgs = gallery.querySelectorAll('[data-media-id="mw-sizes"] svg image');
    var art = null;
    try {
      var data = JSON.parse(picker.querySelector('script[type="application/json"]').textContent);
      (data.variants || []).some(function (v) {
        if (/no frame/i.test(v.title) && !/cloud|bathy/i.test(v.title) && v.featured_image) { art = v.featured_image.src; return true; }
      });
      if (!art) (data.variants || []).some(function (v) {
        if (/no frame/i.test(v.title) && v.featured_image) { art = v.featured_image.src; return true; }
      });
    } catch (e) {}
    if (!art || !imgs.length) return;
    art = art.replace(/^\/\//, 'https://');
    var sep = art.indexOf('?') > -1 ? '&' : '?';
    imgs.forEach(function (im) { im.style.opacity = '0'; }); // no flash of the generic map

    function apply(box, ratio) {
      imgs.forEach(function (im) {
        var id = (im.getAttribute('clip-path') || '').replace(/^url\(#|\)$/g, '');
        var r = id && im.ownerSVGElement && im.ownerSVGElement.querySelector('[id="' + id + '"] rect');
        if (r) {
          var mx = +r.getAttribute('x'), my = +r.getAttribute('y'), w = +r.getAttribute('width'), h = +r.getAttribute('height');
          // Size of the whole file on the wall so the artwork box covers the print (cut at most a sliver).
          var W = Math.max(w / box.w, h / (box.h * ratio)), H = W * ratio;
          im.setAttribute('href', art + sep + 'width=900');
          im.setAttribute('preserveAspectRatio', 'none');
          im.setAttribute('width', W);
          im.setAttribute('height', H);
          im.setAttribute('x', mx + w / 2 - W * (box.x + box.w / 2));
          im.setAttribute('y', my + h / 2 - H * (box.y + box.h / 2));
        }
        im.style.opacity = '';
      });
    }
    // Typical layout if measuring is not possible: square file, artwork centred, ~87% wide.
    var fallback = { x: 0.065, y: 0.065, w: 0.87, h: 0.87 };

    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onerror = function () { apply(fallback, 1); };
    probe.onload = function () {
      var nw = probe.naturalWidth, nh = probe.naturalHeight, box = null;
      try {
        var c = document.createElement('canvas'); c.width = nw; c.height = nh;
        var ctx = c.getContext('2d'); ctx.drawImage(probe, 0, 0);
        var d = ctx.getImageData(0, 0, nw, nh).data, x0 = nw, y0 = nh, x1 = -1, y1 = -1;
        for (var y = 0; y < nh; y++) for (var x = 0; x < nw; x++) {
          var k = (y * nw + x) * 4;
          if (d[k] < 238 || d[k + 1] < 238 || d[k + 2] < 238) {
            if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y;
          }
        }
        if (x1 > x0 && y1 > y0) box = { x: x0 / nw, y: y0 / nh, w: (x1 - x0 + 1) / nw, h: (y1 - y0 + 1) / nh };
      } catch (e) {}
      apply(box || fallback, nh / nw);
    };
    probe.src = art + sep + 'width=300&mw_probe=1'; // own URL so a cached non-CORS copy is not reused
  }

  var tries = 0;
  function wait() {
    if (setup() || ++tries > 75) return;
    setTimeout(wait, 200);
  }

  // Desktop stays out of this until the class arrives, e.g. a window narrowed to mobile width.
  if (active()) {
    wait();
  } else {
    new MutationObserver(function (m, obs) {
      if (!active()) return;
      obs.disconnect();
      wait();
    }).observe(root, { attributes: true, attributeFilter: ['class'] });
  }
})();
